export const getFrameAttrs = () => {
  let isEmbedded = 'no';
  let parentUrl = '';
  let embeddedUrl = '';

  try {
    isEmbedded = window.self !== window.top ? 'yes' : 'no';
  } catch (e) {
    isEmbedded = 'yes';
  }

  if (isEmbedded === 'yes') {
    parentUrl = document.referrer;
    embeddedUrl = window.location.href;
  }

  return { isEmbedded, parentUrl, embeddedUrl };
};
